import { useQuery } from "@tanstack/react-query";
import { getCurrencyRates } from "../utility/httpActions/currencyRateActions";

// USD value of 1 unit per currency, or null when the backend has nothing fresh
// enough to show. Rates change daily at most.
export const useCurrencyRates = ({ enabled = true } = {}) => {
  const { data } = useQuery({
    queryKey: ["currencyRates"],
    queryFn: getCurrencyRates,
    enabled,
    staleTime: 6 * 60 * 60 * 1000,
  });
  return data?.rates ?? null;
};
